module.exports = __webpack_public_path__ + "static/img/icon_yszp.c4c48021.png";